<template>
  <div class="mini-cart-item">
    <product-info :image="image"
                  :brand="brand"
                  :name="$props.entries.product.name"/>
    <tariff-info :cycleEnd="priceType.cycleEnd"
                 :price="priceType.price.formattedValue"
                 :currency="priceType.price.currencyIso"
                 :brand="brand"
                 :icon="icon"
                 :entryNumber="entries.entryNumber"/>
  </div>
</template>

<script>
import ProductInfo from '@/components/mini-cart/product-info'
import TariffInfo from '@/components/mini-cart/tariff-info'
export default {
  name: 'mini-cart-item',
  components: { ProductInfo, TariffInfo },
  props: {
    entries: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    image () {
      return this.$props.entries.product?.images?.[0].url
    },
    brand () {
      return this.$props.entries.product?.brands?.[0].name
    },
    priceType () {
      return this.$props.entries?.monthlyPrice || this.$props.entries?.oneTimePrice
    },
    icon () {
      return !this.image && !this.brand ? '/assets/images/trash-gray.svg' : '/assets/images/remove-circle-gray.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-cart-item {
  display: flex;
  align-items: center;
  padding: 1.6rem 2.4rem;

  &:not(:last-child) {
    border-bottom: .1rem solid $border-color;
  }
}
</style>
